import EditAboutModal from './EditAboutModal'

export default EditAboutModal
